import { render } from "./BDropdownItem.vue?vue&type=template&id=e6850e78&scoped=true"
import script from "./BDropdownItem.vue?vue&type=script&lang=js"
export * from "./BDropdownItem.vue?vue&type=script&lang=js"

import "./BDropdownItem.vue?vue&type=style&index=0&id=e6850e78&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6850e78"]])

export default __exports__